import React from 'react';
import { Member } from '@springbig/shared';
import { Box } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useReferStyles } from '~/shared/styles';

type ReferRewardsProps = {
    member: Member;
};

const ReferRewards = ({ member }: ReferRewardsProps) => {

    const {
        text,
    } = useReferStyles();

    return (
        <Box w={'100%'}>
            <Caption textAlign={'center'}>
                {
                    member &&
                    member.referrals.action &&
                    member.referrals.action === '3' && (
                        <Caption
                            color={text}
                            text='refer.text_prize_purchase'
                            textValues={[Number(member.referrals.min_purchase) > 0 ? `$${member?.referrals?.min_purchase}` : '']}

                        />
                    )
                }
                {
                    member &&
                    member.referrals.action &&
                    member.referrals.action === '2' && (
                        <Caption
                            color={text}
                            text='refer.text_prize'
                        />
                    )
                }
                <Caption
                    fontWeight={500}
                    color={text}
                >
                    { ' ' + member.referrals.referrer_offer_name + ' ' }
                </Caption>
                { member &&
                    member.referrals.show_referrer_offer &&
                    member.referrals.referred_offer_name && (
                    <>
                        <Caption
                            color={text}
                            text='refer.text_receiver'
                            mr={1}
                        />
                        <Caption
                            fontWeight={500}
                            color={text}
                        >
                            { member.referrals.referred_offer_name }
                        </Caption>
                    </>
                )}
            </Caption>
        </Box>
    );
};


export default ReferRewards;
